import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryContext } from "../../../core/contexts/query"
import { usePredictContext } from "../context/PredictContextProvider"
import { useMainContext } from "../../../modules/Dashboard"
import { usePredictionSocket } from "./usePredictionSocket"
import { useGetTickerDetails, useGetTickerDetailsForce } from "../services/usePredict"


export const useResultData = () => {
    const { setToast } = useQueryContext()
    const navigate = useNavigate()
    const { ticker, step, refetch, responseType, reset: resetPredictContext, assistant, timeFrame, predictHistory } = usePredictContext()
    const { setMarket } = useMainContext()

    // Force fetch (initial)
    const {
        data: initialData,
        isLoading: forceDataIsLoading,
        error: detailsForceError,
        refetch: refetchDetails
    } = useGetTickerDetailsForce({
        ticker,
        responseType,
        assistant: assistant.assistant?.value,
        frame: timeFrame,
        enabled: !predictHistory.predictHistoryId && step.currentStep === "result"
    })

    // WebSocket (cached data)
    const {
        cachedData,
        servedId,
        error: socketError,
        loading: socketLoading,
        reset
    } = usePredictionSocket(initialData, !predictHistory.predictHistoryId)

    // API fetch for live data
    const {
        data: liveData,
        isLoading: dataIsLoading,
        isFetching: dataIsFetching,
        error: detailsLiveError
    } = useGetTickerDetails({
        requestId: servedId || predictHistory.predictHistoryId,
        responseType,
        enabled: (!cachedData && !!servedId) || !!predictHistory.predictHistoryId
    })

    // Combined states
    const loading = forceDataIsLoading || socketLoading || (dataIsLoading || dataIsFetching)
    const error = detailsForceError || socketError || detailsLiveError
    const data = useMemo(() => cachedData || liveData, [cachedData, liveData])

    // Sync ticker with market
    useEffect(() => {
        if (ticker) {
            const [coin, pair] = ticker.split("-")
            setMarket({ coin: coin?.toLowerCase(), pair: pair?.toLowerCase() })
        }
    }, [ticker])

    // Handle manual refetch
    useEffect(() => {
        if (refetch.shouldRefetch) {
            reset()
            refetchDetails()
            refetch.setShouldRefetch(false)
        }
    }, [refetch])

    // Handle error
    useEffect(() => {
        if (error) {
            if (error?.response?.status === 406) {
                return
            } else {
                resetPredictContext()
                reset()
                setToast({ show: true, message: error, isError: true })
                navigate("/analyze/assistant?step=tickers")
            }
        }
    }, [error])

    // return { data: forextMulti, loading: false }
    return { data, loading, error }
}
